import styled from 'styled-components';

export const SurveyOverviewNavigationList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
